import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import DOMPurify from "dompurify";
import { Row, Button, Typography, Tag, Modal } from "antd";
import { RightOutlined } from "@ant-design/icons";
import _get from "lodash/get";
import LoadingIndicator from "components/LoadingIndicator";
import "./styles.less";
import Helper from "utils/helpers";
import BackButton from "components/BackButton";
import {
  getConsulateDetailRequest,
  deleteConsulateRequest,
  getAllConsulateRequest,
} from "providers/ConsulateProvider/slice";

const ConsulateDetail = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const detail = useSelector((state) => state.consulate.detail);
  const isLoading = useSelector((state) => state.consulate.isLoading);
  const docs = useSelector((state) => _get(state, "consulate.docs", []));

  const { id } = useParams();

  useEffect(() => {
    dispatch(getConsulateDetailRequest({ idCategory: id }));
    dispatch(getAllConsulateRequest({ page: 1, limit: 100 }));
  }, [id, dispatch]);

  const createMarkup = (html) => ({
    __html: DOMPurify.sanitize(html, {
      ADD_TAGS: ["iframe"],
      ADD_ATTR: ["allow", "allowfullscreen", "frameborder", "scrolling"],
    }),
  });

  const handleDelete = () => {
    Modal.confirm({
      title: "Xác nhận xóa",
      content: "Bạn có chắc chắn muốn xóa danh mục này?",
      okText: "Xóa",
      cancelText: "Hủy",
      okType: "danger",
      onOk: () =>
        dispatch(deleteConsulateRequest({ idCategory: [id] })).then(() =>
          navigate("/consulate/consulate_categories", { replace: true })
        ),
    });
  };

  if (isLoading) {
    return <LoadingIndicator />;
  }

  return (
    <div className="consulate-detail-wrapper">
      <Row
        className="consulate-detail-header"
        justify="space-between"
        align="middle"
      >
        <Row>
          <BackButton />
          <Typography.Title level={4}>Chi tiết danh mục</Typography.Title>
        </Row>
        <div className="header-buttons">
          <Button size="large" danger onClick={handleDelete}>
            Xóa
          </Button>
          <Button
            size="large"
            type="primary"
            onClick={() =>
              navigate(`/consulate/consulate_categories/${id}/edit`, {
                state: { canGoBack: true },
              })
            }
          >
            Cập nhật
          </Button>
        </div>
      </Row>
      <div className="detail-body">
        <div className="detail-wrapper">
          <div className="detail-title-wrapper">
            <div className="detail-title">
              {detail.emoji && (
                <span style={{ marginRight: 8 }}>{detail.emoji}</span>
              )}
              {detail.title}
            </div>
            <div className="detail-time">
              <div className="time-dot" />
              {Helper.getTimeStamp(detail.createdAt)}
            </div>
          </div>
          <div className="detail-meta">
            {detail.url && (
              <div className="meta-item">
                <span className="meta-label">URL:</span>
                <a href={detail.url} target="_blank" rel="noopener noreferrer">
                  {detail.url}
                </a>
              </div>
            )}
            {detail.contactInfo && (
              <div className="meta-item">
                <span className="meta-label">Liên hệ:</span>
                <span>{detail.contactInfo}</span>
              </div>
            )}
            <div className="meta-item">
              <span className="meta-label">Trạng thái:</span>
              <Tag color={detail.isActive ? "green" : "red"}>
                {detail.isActive ? "Đang hoạt động" : "Không hoạt động"}
              </Tag>
            </div>
          </div>
          <div
            className="content-wrapper"
            dangerouslySetInnerHTML={createMarkup(detail.description)}
          />
        </div>
        <div className="detail-sidebar">
          <div
            className="sidebar-support-btn"
            onClick={() =>
              navigate("/consulate/consulate_messengers", {
                state: { canGoBack: true },
              })
            }
          >
            <span>Hỗ trợ trực tuyến</span>
            <RightOutlined />
          </div>
          <div className="sidebar-category-list">
            {docs.map((doc) => (
              <div
                key={doc._id}
                className={`sidebar-category-item${doc._id === id ? " active" : ""}`}
                onClick={() =>
                  navigate(`/consulate/consulate_categories/${doc._id}`, {
                    state: { canGoBack: true },
                  })
                }
              >
                <span className="category-text">
                  {doc.emoji && <span className="category-emoji">{doc.emoji}</span>}
                  {doc.title}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConsulateDetail;
